/**
 * Stitching review 5.2 -- one matter's thread, from GET /v1/thread.
 * Shared because the strip appears on Twin pages (service, finding)
 * and on Framework pages (letter), and neither may import the other.
 */
import { type UseQueryResult, useQuery } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { IBSThread } from "shared/api/types";

/** Stitching review 5.2 -- the five-stage thread for one matter. */
export type ThreadSubject = "ibs" | "finding" | "letter" | "scenario";

export function useThread(
  subject: ThreadSubject,
  id: string | undefined,
  /** Round 18 R7 -- a letter read from one plan's page: the thread about
   *  that plan. */
  capId?: string,
): UseQueryResult<IBSThread, ApiError> {
  const query = capId ? `?cap=${encodeURIComponent(capId)}` : "";
  return useQuery({
    queryKey: id
      ? (["thread", subject, id, capId ?? null] as const)
      : (["thread", subject, "_disabled"] as const),
    queryFn: () => api.get<IBSThread>(`/v1/thread/${subject}/${id}${query}`),
    enabled: !!id,
    staleTime: 60_000,
    retry: (count, err) => err.status !== 404 && err.status !== 403 && count < 2,
  });
}
